import { useStorage } from '@vueuse/core'
import { ref, watch, onMounted } from 'vue'
export const useTheme = () => {
  const appConfig = useAppConfig()
  const primaryColor = useStorage('primaryColor', 'blue')
  const themeColor = useStorage('themeColor')
  const colorMode = useColorMode()
  const isLightTheme = ref()

  const setPrimaryColor = (color) => {
    primaryColor.value = color
    appConfig.ui.colors.primary = color
  }

  const setThemeColor = (color) => {
    themeColor.value = color
    appConfig.ui.colors.neutral = color
  }
  const toggleTheme = () => {
    isLightTheme.value = !isLightTheme.value
  }

  watch(
    () => isLightTheme.value,
    (val) => {
      const theme = !val ? 'dark' : 'light'
      colorMode.preference = theme
    }
  )

  onMounted(() => {
    if (colorMode.value === 'light') {
      isLightTheme.value = true
    }
  })

  return {
    currentColor: primaryColor,
    currentBgColor: themeColor,
    setPrimaryColor,
    setThemeColor,
    toggleTheme,
    isLightTheme,
  }
}
